import { SET_FILTERS } from "./types";

export const setFiltersAction = filter => ({
  type: SET_FILTERS,
  payload: filter
});



// WEBPACK FOOTER //
// ./src/services/filters/actions.js